import { render, staticRenderFns } from "./UserNews.vue?vue&type=template&id=74775faa&scoped=true"
import script from "./UserNews.vue?vue&type=script&lang=js"
export * from "./UserNews.vue?vue&type=script&lang=js"
import style0 from "./UserNews.vue?vue&type=style&index=0&id=74775faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74775faa",
  null
  
)

export default component.exports